import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LoaderFullScreenComponent } from './components/loader-full-screen/loader-full-screen.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BlockUIModule } from 'primeng/blockui';
import { AgmCoreModule } from '@agm/core';
import { FileUploadModule } from 'primeng/fileupload';
import { DragDropDirective } from './directives/drag-drop.directive';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { ValidaAccesoDirective } from './directives/valida-acceso.directive';


@NgModule({
  declarations: [
    LoaderFullScreenComponent,
    DragDropDirective,
    ValidaAccesoDirective
  ],
  imports: [
    CommonModule,
    ProgressSpinnerModule,
    BlockUIModule,
    AgmCoreModule,
    FileUploadModule,
    FormsModule,
    ReactiveFormsModule,
    RadioButtonModule,
    InputTextModule,
    DropdownModule,
    CalendarModule,
    DropdownModule
  ],
  exports: [
    LoaderFullScreenComponent,
    DragDropDirective,
    ValidaAccesoDirective
  ],
  providers: [DatePipe]
})
export class SharedModule { }
